import { IconFieldDesignTokens } from '@primeng/themes/types/iconfield';

export const baseIconFieldToken: IconFieldDesignTokens = {};
